<template>
  <div :class="{
    'sub-layer-checkbox': true,
    'sub-layer-checkbox--checked': checked,
  }">
    <div class="sub-layer-checkbox__content">

      <div class="sub-layer-checkbox__row">
        <div :class="{
          'sub-layer-checkbox__input': true,
          'sub-layer-checkbox__input--checked': checked
        }">
          <input 
            :id="`sub-${label}`"
            type="checkbox"
            @change="$emit('change', $event)"
            :checked="checked"
            value="checked">
        </div>
        <div v-if="isDynamic" class="sub-layer-checkbox__icon-wrapper">
            <div 
              v-if="icon"
              class="sub-layer-checkbox__icon"
              :class="{'sub-layer-checkbox__icon--active': checked}"
              :style="`mask: url(data:image/svg+xml;base64,${icon}) no-repeat center; mask-size: contain;`"
            ></div>
        </div>
        <div v-else class="sub-layer-checkbox__icon-wrapper">
          <div 
            class="sub-layer-checkbox__icon"
            :class="{'sub-layer-checkbox__icon--active': checked}"
            :style="`mask: url(${getIconUrl(icon)}) no-repeat center;`"
          ></div>

        </div>
      </div>
    </div>
    <label :for="`sub-${label}`"  class="sub-layer-checkbox__title" :class="{'sub-layer-checkbox__title--active': checked}">
      <span v-if="isDynamic">
        <span v-if="hasTranslation">
          <translated-text-component :translation="label" />
        </span>
        <span v-else>
          {{ label }}
        </span>
      </span>
      <span v-else>
        <translated-text-component :translation="label" />
      </span>
    </label>
  </div>
</template>

<script lang="ts">
import AssetIconService from '@/services/AssetIconService';
import { defineComponent, ref } from 'vue';

const SubLayerCheckbox: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    icon: {
      type: String,
      name: 'icon',
    },
    label: {
      type: String,
      default: '<BRAK DANYCH>',
      name: 'label',
    },
    parentState: {
      type: Boolean,
      default: true,
      name: 'parentState',
    },
    isDynamic: {
      type: Boolean,
      default: false,
      name: 'isDynamic',
    },
    hasTranslation: {
      type: Boolean,
      default: false,
      name: 'hasTranslation',
    },
  },
  name: 'SubLayerCheckbox',
  setup() {
    const getIconClassName = (icon: string) => {
      const iconNamePrefix = icon.split('-')[0];

      return iconNamePrefix === 'mdi' ? `mdi ${icon}` : icon;
    };

    const getIconUrl = (iconName: string) => AssetIconService.getNavStandardSvgUrl(iconName);

    return {
      getIconUrl,
      getIconClassName,
    };
  },
});
export default SubLayerCheckbox;
</script>

<style scoped lang="scss">

.sub-layer-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: rem(32px);
  margin-bottom: rem(8px);

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    @include width-from($mobile) {
      .sub-layer-checkbox__title {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  &:not(:last-of-type) {
    @include width-from($mobile) {
      // margin-bottom: rem(8px);
    }
  }

  &__row {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    opacity: 1;
    transition: opacity ease-in-out 0.3s;

  }

  &__icon-wrapper {
    display: flex;
    align-items: center;
    min-width: 34px;
  }

  &--checked {
    .sub-layer-checkbox__icon {
      i {
        color: $layer-icon-on;
      }
    }
  }

  &__input {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background: transparent;
    bottom: 0;
    left: 0;
    right: 0;

    input {
      opacity: 0;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 2;
      cursor: pointer;
    }

    &--checked {
      &:after {
        opacity: 1;
      }
    }
  }

  &__icon {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: $layer-icon-off;

    &--active {
      background-color: $layer-icon-on;
    }

    i {
      height: 100%;
      font-size: rem(36px);
      color: $layer-icon-off;
      font-size: rem(26px);
      line-height: 1;

      &::before {
        color: currentColor;
      }
    }
  }

  &__title {
    word-wrap: break-spaces;
    letter-spacing: rem(0.7px);
    font-weight: 500;
    padding: rem(4px) rem(8px);
    border-radius: rem(14px);
    transition: .5s;
    color: $white-static;
    background-color: $main-bg-color;
    font-size: rem(10px);
    font-weight: 700;
    border: 1px solid $main-bg-color;
    text-align: left;

    &--active {
      color: $menu-text-active;
    }


    &:hover {
      text-decoration: none;
    }
  }

  &__label {
    // display: none;
  }
}
</style>
